module.exports = __webpack_public_path__ + "img/earnings-up.05ee9fcb.svg";